import { styled } from '@mui/material'
import { ReactNode } from 'react'

interface ProcessStepProps {
  icon: ReactNode
  title: ReactNode
  children: ReactNode
}

const Li = styled('li')(({ theme }) => ({
  '& > svg:first-of-type': {
    width: 'auto',
    display: 'block',
    margin: '0 auto',
    height: 48,
    [theme.breakpoints.up('md')]: { height: 64 },
  },
  '& h5': {
    fontSize: '1.125rem',
    fontWeight: 600,
    padding: 0,
    margin: 0,
    marginBlock: 0,
    marginInline: 0,
    marginTop: 16,
    [theme.breakpoints.up('md')]: {
      fontWeight: 700,
      fontSize: '1.5rem',
    },
  },
  '& p': {
    margin: 0,
    padding: 0,
    fontWeight: 500,
  },
  display: 'inline-block',
  textAlign: 'center',
  verticalAlign: 'top',
  [theme.breakpoints.up('md')]: { width: 'calc((100% - 64px)/3)' },
}))

const ProcessStep = ({
  icon,
  title,
  children,
}: ProcessStepProps): JSX.Element => {
  return (
    <Li>
      {icon}
      <h5>{title}</h5>
      <p>{children}</p>
    </Li>
  )
}

export default ProcessStep
